export const TAC_URL = 'https://checkout.volt.io/legal-providers';
